import React from 'react'
import Tooltip from 'lib/components/tooltip'
import Icon from 'lib/components/icon'
import RA from 'ra-config'
import * as placeholder from 'lib/config/placeholder'

const { methodText, methodTitle } = RA.content

const MethodTooltip = function() {
  const newMethodText = placeholder.replace(methodText)

  return (
    <Tooltip
      className="header__button header__method"
      placement="bottom"
      overlay={newMethodText}
    >
      <span>
        <span className="header__method__title">{methodTitle}</span>{' '}
        <Icon type="info" height="22px" width="22px" fill="#fff" />
      </span>
    </Tooltip>
  )
}

export default MethodTooltip



// WEBPACK FOOTER //
// ./src/components/method-tooltip.js